<template>
  <div class="manage-goods-container">
    <div>
      <h2>套餐管理</h2>
    </div>
    <!-- 状态切换tabs -->
    <StatusChangeBar @statusChange="statusChange" />
    <!-- 搜索条 -->
    <SearchBar @searchClick="searchClick" @resetClick="resetClick" />
    <!-- 表格 -->
    <div class="table-box">
      <el-table
        v-loading="isLoading"
        :data="spuList"
        style="width: 100%; margin-bottom: 20px"
        row-key="uniqueKey"
        border
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      >
        >
        <el-table-column type="index" width="50">
          <template slot-scope="scope">
            <template v-if="scope.row.isSpu">
              <el-checkbox v-model="scope.row.checked" @change="oneSpuCheckedChange"></el-checkbox>
            </template>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="name" label="商品名称" min-width="20%" />
        <el-table-column align="center" label="商品图片" min-width="15%">
          <template slot-scope="scope">
            <el-image style="width: 50px; height: 50px" :src="scope.row.picUrl" fit="cover"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="价格(元)" min-width="10%">
          <template slot-scope="scope">
            <template v-if="scope.row.specType === 0">{{ scope.row.children && scope.row.children[0].marketPriceStr }}</template>
            <template v-else>
              <div>
                {{ scope.row.marketPriceStr }}
              </div>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="单位" min-width="10%">
          <template slot-scope="scope">
            <template v-if="scope.row.specType === 0">{{ scope.row.children && scope.row.children[0].unitName }}</template>
            <template v-else>
              <div>
                {{ scope.row.unitName }}
              </div>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="库存" min-width="20%">
          <template slot-scope="scope">
            <el-popover placement="top" width="193" trigger="click" v-model="scope.row.popoverVisible" v-if="scope.row.isSpu">
              <div v-if="scope.row.isSpu" class="flex items-center" slot="reference">
                <span>{{ scope.row.currQuantity }}</span>
                <i class="el-icon-edit mar5-l"></i>
              </div>
              <div>
                <h4>修改库存</h4>
                <div style="display: flex; margin-top: 7px">
                  <el-input
                    size="mini"
                    type="number"
                    :min="0"
                    :max="99999"
                    oninput="if(value){value=value.replace(/[^\d]/g,'')} if(value<=0){value=''} if(value>99999){value=99999}"
                    v-model="scope.row.currQuantity"
                    placeholder="商品库存"
                    @input="batchStockInput"
                    @change="batchStockChange"
                  ></el-input>
                </div>
                <div class="mar10-t">
                  <el-button size="mini" @click="batchStockCancle(scope.row.id)">取消</el-button>
                  <el-button size="mini" type="primary" @click="batchStockSure(scope.row)">确定</el-button>
                </div>
              </div>
            </el-popover>
            <template v-else
              ><span>{{ scope.row.currQuantity }}</span></template
            >
          </template>
        </el-table-column>
        <el-table-column label="分类" min-width="20%">
          <template slot-scope="scope">
            <template v-if="scope.row.isSpu">
              <span v-if="scope.row.goodsType">{{ scope.row.goodsType }}</span>
              <i v-if="scope.row.goodsType" class="el-icon-edit mar5-l" @click="showCategroyDialogClick(scope.row)"></i>
              <el-button v-else type="text" @click="showCategroyDialogClick(scope.row)">+添加</el-button>
            </template>
            <template v-else><div class="nodata_line_color">——</div></template>
          </template>
        </el-table-column>
        <el-table-column label="状态" min-width="10%">
          <template slot-scope="scope">
            <template v-if="scope.row.isSpu">
              <span v-if="scope.row.status == 1"> 已保存 </span>
              <span v-if="scope.row.status == 2" style="color: #1890ff"> 待审核 </span>
              <span v-if="scope.row.status == 3" style="color: #ff7f27"> 驳回 </span>
              <span v-if="scope.row.status == 9" style="color: #ff7f27"> 店铺驳回 </span>
              <span v-if="scope.row.status == 5" style="color: #188506"> 出售中 </span>
              <span v-if="scope.row.status == 6" style="color: red"> 已下架 </span>
              <span v-if="scope.row.status == 8" style="color: red"> 强制下架 </span>
            </template>
            <template v-else class="nodata_line_color"><div class="nodata_line_color">——</div></template>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <template v-if="scope.row.isSpu">
              <el-button v-if="scope.row.status != 2 && scope.row.status != 3" size="mini" @click="editSpuClick(scope.row)">编辑</el-button>
              <el-button v-if="scope.row.status == 5" size="mini" @click="oneXiaJia(scope.row)">下架</el-button>
              <el-button v-if="scope.row.status == 1 || scope.row.status == 6" size="mini" @click="oneShangJia(scope.row)">上架</el-button>
              <el-button v-if="scope.row.status == 2" size="mini" @click="cancelAudit(scope.row)">取消审核</el-button>
              <el-button v-if="scope.row.status == 3" size="mini" @click="editSpuClick(scope.row)">重新编辑</el-button>
              <el-button
                v-if="scope.row.status == 1 || scope.row.status == 3 || scope.row.status == 6 || scope.row.status == 8"
                size="mini"
                @click="goodsDeleteClick(scope.row)"
                >删除</el-button
              >
              <el-button v-if="scope.row.status != 3" size="mini" @click="lookQRCodeClick(scope.row)">二维码</el-button>
            </template>
            <template v-else>
              <el-button v-if="scope.row.status != 3" size="mini" @click="lookQRCodeClick(scope.row)">二维码</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="bottom-handle-box">
      <el-checkbox v-model="selectAll">全选</el-checkbox>
      <el-divider direction="vertical"></el-divider>
      <el-button type="text" style="color: #606266" @click="batchShangJia">批量上架</el-button>
      <el-button type="text" style="color: #606266" @click="batchXiaJia">批量下架</el-button>
      <el-button type="text" style="color: #606266" @click="batchaddCate">批量分类</el-button>
      <el-button type="text" style="color: #606266" @click="batchDeleteClassify">移除分类</el-button>
    </div>
    <div class="pagination-box">
      <el-pagination background layout="prev, pager, next" :total="total" :current-page="currentPage" @current-change="handleCurrentChange"> </el-pagination>
    </div>
    <CategoryDialog ref="categoryDialogref" v-if="showCategoryDialog" :showCategoryDialog.sync="showCategoryDialog" @reloadspuList="reloadspuList" />
    <el-dialog title="二维码" :visible.sync="showQRCodeDialog" width="260px">
      <el-row type="flex" justify="center">
        <div class="qrCode-box">
          <canvas ref="qrCodeCanvas" />
          <div class="img-box">
            <el-image style="width: 20px; height: 20px" :src="showQRDialogImgUrl" fit="cover"></el-image>
          </div>
        </div>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { getGoodsShopCategory } from "@/api/publishGoods/publishGoods";
import { getGoodsSpuList, goodsModifyStatus, goodsShopClassifyDelete, goodsDelete, editCurrQuantity } from "@/api/manageGoods/manageGoods";
import QrCode from "qrcode";
import StatusChangeBar from "./components/StatusChangeBar.vue";
import SearchBar from "./components/SearchBar.vue";
import CategoryDialog from "./components/CategoryDialog.vue";

export default {
  components: {
    StatusChangeBar,
    SearchBar,
    CategoryDialog,
  },
  data() {
    return {
      status: "", //当前要查看哪种状态
      name: "", // 搜索框输入的商品名称
      customCateId: "", // 搜索框,分类id
      currentPage: 1, //当前页码
      total: 0, // 总共多少条数据
      isLoading: false, // 是否正在加载
      spuList: [],
      showCategoryDialog: false,
      showQRCodeDialog: false, // 是否展示二维码
      showQRDialogImgUrl: "", // 二维码url
      batchStockObj: {
        batchStock: "",
        batchSelectType: "1",
        batchStockShow: false,
        batchStockNullError: false,
        batchStockFuError: false,
      },
    };
  },
  created() {
    this.loadGetGoodsSpuList();
    this.loadGetGoodsShopCategory();
  },
  computed: {
    // 全选按钮是否选中
    selectAll: {
      get() {
        return this.spuList.length && this.spuList.every((item) => item.checked);
      },
      // 设置全选或者全不选
      set(value) {
        this.spuList.forEach((item) => (item.checked = value));
        this.spuList = [...this.spuList];
      },
    },
  },
  methods: {
    async loadGetGoodsShopCategory() {
      const result = await getGoodsShopCategory();
      this.customCateList = result.data;
    },
    async loadGetGoodsSpuList() {
      this.spuList = [];
      const params = {
        size: 10, // 页码大小
        current: this.currentPage,
      };

      if (this.status) {
        params.status = this.status;
      }

      if (this.name) {
        params.name = this.name;
      }

      if (this.customCateId) {
        params.shopDecorateId = this.customCateId;
      }
      params.isGroup = 1;
      try {
        this.isLoading = true;
        const result = await getGoodsSpuList(params);
        this.total = result.data.total;
        // 开始洗数据
        // const spuList = [];

        this.spuList = result.data.records.map((spuItem) => {
          return {
            ...spuItem,
            children: spuItem.skuList,
            isSpu: true, // 这一级是spu
            checked: false,
            isoa: 0,
            hasChildren: spuItem.specType === 0,
          };
        });

        // for (let index = 0; index < result.data.records.length; index++) {
        //   const spuItem = result.data.records[index];

        //   // 算一下每个spu的总库存
        //   const totalQuantity = spuItem.skuList.reduce((sum, item) => sum + item.currQuantity, 0);

        //   const spuObj = {
        //     ...spuItem,
        //     isSpu: true, // 这一级是spu
        //     checked: false,
        //     goodsId: `${spuItem.id}${spuItem.createTime}`, //
        //     currQuantity: totalQuantity,
        //     isoa: 0
        //   };

        //   if (spuItem.skuList.length && spuItem.specType !== 0) {
        //     spuObj.isoa = spuItem.skuList[0].isoa;
        //     spuObj.children = spuItem.skuList;
        //   }

        //   spuList.push(spuObj);
        // }
        // this.spuList = spuList;
        this.isLoading = false;
        console.log("数组", this.spuList);
      } catch (error) {
        this.isLoading = false;
      }
    },
    //状态status改变赋值,重新请求数据
    statusChange({ name }) {
      this.currentPage = 1;
      this.status = name;
      this.loadGetGoodsSpuList();
    },
    //搜索点击获取值
    searchClick({ name, customCateId }) {
      this.name = name;
      this.customCateId = customCateId;
      this.loadGetGoodsSpuList();
    },
    //重置点击了
    resetClick() {
      this.currentPage = 1;
      this.name = "";
      this.customCateId = "";

      this.loadGetGoodsSpuList();
    },
    //改变当前页码
    handleCurrentChange(page) {
      this.currentPage = page;
      this.loadGetGoodsSpuList();
    },
    oneSpuCheckedChange() {
      this.spuList = [...this.spuList];
    },
    // 批量事件,获取spuids
    getCheckedSpuIds() {
      const spuIds = [];
      this.spuList.forEach((item) => {
        if (item.checked) {
          spuIds.push(item.id);
        }
      });

      if (spuIds.length) {
        return spuIds;
      } else {
        this.$message.error("请选择商品!");
        return;
      }
    },
    // 展示分类dialog
    async showCategroyDialogClick(obj) {
      this.showCategoryDialog = true;
      await this.$nextTick();
      this.$refs.categoryDialogref.spuIds = [obj.id];
    },
    //编辑,重新编辑spu
    editSpuClick(obj) {
      this.$router.push(`publishgoods?spuId=${obj.id}`);
    },
    // 单一上架
    async oneShangJia(obj) {
      try {
        const result = await goodsModifyStatus({ status: 5, spuIds: [obj.id] });

        if (result.code == 0 || result.code == 3) {
          this.$message.success(result.msg || "上架成功");
          this.loadGetGoodsSpuList();
        } else {
          this.$message.error(result.msg || "上架失败");
        }
      } catch (error) {
        this.$message.error("上架失败");
      }
    },
    // 单一下架
    async oneXiaJia(obj) {
      try {
        const result = await goodsModifyStatus({ status: 6, spuIds: [obj.id] });

        if (result.code != 0) {
          this.$message.error(result.msg || "下架失败");
        } else {
          this.$message.success("下架成功");
          this.loadGetGoodsSpuList();
        }
      } catch (error) {
        this.$message.error("下架失败");
      }
    },
    // 取消审核
    async cancelAudit(obj) {
      try {
        const result = await goodsModifyStatus({ status: 1, spuIds: [obj.id] });

        if (result.code != 0) {
          this.$message.error(result.msg || "取消审核失败");
        } else {
          this.$message.success("取消审核成功");

          this.loadGetGoodsSpuList();
        }
      } catch (error) {
        this.$message.error("取消审核失败");
      }
    },
    // 删除
    async goodsDeleteClick(obj) {
      try {
        const result = await goodsDelete({ spuIds: [obj.id] });

        if (result.code != 0) {
          this.$message.error(result.msg || "删除失败");
        } else {
          this.$message.success("删除成功");

          this.loadGetGoodsSpuList();
        }
      } catch (error) {
        this.$message.error("删除失败");
      }
    },
    //查看二维码
    async lookQRCodeClick(obj) {
      this.showQRCodeDialog = true;
      await this.$nextTick();

      this.showQRDialogImgUrl = obj.picUrl;

      let goodsId = obj.goodsId;
      QrCode.toCanvas(this.$refs.qrCodeCanvas, `${process.env.VUE_APP_APP}goods/queryGoodsDetailInfo/${goodsId}`);
    },
    // 批量上架
    async batchShangJia() {
      const spuIds = this.getCheckedSpuIds();
      if (!spuIds) {
        return;
      }

      try {
        const result = await goodsModifyStatus({ status: 5, spuIds });

        if (result.code == 0 || result.code == 3) {
          this.$message.success(result.msg || "上架成功");
          this.loadGetGoodsSpuList();
        } else {
          this.$message.error(result.msg || "上架失败");
        }
      } catch (error) {
        this.$message.error("上架失败");
      }
    },
    // 批量下架
    async batchXiaJia() {
      const spuIds = this.getCheckedSpuIds();
      if (!spuIds) {
        return;
      }

      try {
        const result = await goodsModifyStatus({ status: 6, spuIds });

        if (result.code != 0) {
          this.$message.error(result.msg || "下架失败");
        } else {
          this.$message.success("下架成功");

          this.loadGetGoodsSpuList();
        }
      } catch (error) {
        this.$message.error("下架失败");
      }
    },
    // 批量分类
    async batchaddCate() {
      const spuIds = this.getCheckedSpuIds();
      if (!spuIds) {
        return;
      }
      this.showCategoryDialog = true;
      await this.$nextTick();
      this.$refs.categoryDialogref.spuIds = spuIds;
    },
    // 移除分类
    async batchDeleteClassify() {
      const spuIds = this.getCheckedSpuIds();
      if (!spuIds) {
        return;
      }

      try {
        const result = await goodsShopClassifyDelete({ spuIds });

        if (result.code != 0) {
          this.$message.error(result.msg || "移除分类失败");
        } else {
          this.$message.success("移除分类成功");

          this.loadGetGoodsSpuList();
        }
      } catch (error) {
        this.$message.error("移除分类失败");
      }
    },
    reloadspuList() {
      this.loadGetGoodsSpuList();
    },
    //批量修改库存errortips
    batchStockInput() {
      // this.batchStockObj.batchStockNullError = !this.batchStockObj.batchStock;
    },
    //批量修改库存,库存只允许整数
    batchStockChange() {
      /*const stockArr = this.batchStockObj.batchStock.split(".");
      if (stockArr.length <= 1) {
        return;
      }
      this.batchStockObj.batchStock = stockArr[0];*/
    },
    // 库存编辑取消
    batchStockCancle(spuId) {
      console.log("spuId: ", spuId);
      const index = this.spuList.findIndex((item) => item.id == spuId);
      console.log(index);
      this.$set(this.spuList[index], "popoverVisible", false);
    },
    // 库存编辑保存
    async batchStockSure(row) {
      console.log("row: ", row);
      let spuId = row.id;
      let goodsId = row.goodsId;
      const index = this.spuList.findIndex((item) => item.id == spuId);
      console.log(index);
      this.$set(this.spuList[index], "popoverVisible", false);
      let currQuantity = row.currQuantity;
      console.log("currQuantity: ", currQuantity);
      if (currQuantity == "" || currQuantity == null) {
        currQuantity = 0;
        row.currQuantity = 0;
      }
      if (currQuantity < 0) {
        this.$message.error("库存数不能小于0");
        return;
      }
      const result = await editCurrQuantity({ goodsId, currQuantity });
      if (result.code != 0) {
        this.$message.error(result.msg || "修改库存失败");
      } else {
        this.$message.success("修改库存成功");
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/views/seller/publishGoods/changeOuterMainColor.scss";
</style>

<style lang="scss" scoped>
@import "@/views/seller/publishGoods/changeMainColor.scss";
.manage-goods-container {
  padding: 20px;
  .table-box {
    margin-top: 30px;
  }
  .bottom-handle-box {
    padding: 10px;
    border: 1px solid #ebeef5;
  }
  .pagination-box {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
  .qrCode-box {
    position: relative;
    .img-box {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .nodata_line_color {
    color: #e9e9e9;
  }
}
</style>
